(function(){
  'use strict';
  var CX=200,CY=185,RX=140,RY=148,N=60,T=.28,PI2=Math.PI*2;
  var BASE='/products/';
  var selH='',selE='biye',innerScale=.951;
  var currentShape='amorf';
  var liveRX=RX,liveRY=RY;
  var EDGE_CM={biye:1,bordur:3,overlok:0};
  var HANDLE_MAP={"dolce-vita-hali-paradiso-plus-4001-white-ozel-olcu-biyeli":{"biye":"dolce-vita-hali-paradiso-plus-4001-white-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-plus-4001-white-ozel-olcu","overlok":"dolce-vita-hali-paradiso-4001-white-ozel-olcu"},"dolce-vita-hali-paradiso-plus-4001-white-ozel-olcu":{"biye":"dolce-vita-hali-paradiso-plus-4001-white-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-plus-4001-white-ozel-olcu","overlok":"dolce-vita-hali-paradiso-4001-white-ozel-olcu"},"dolce-vita-hali-paradiso-4001-white-ozel-olcu":{"biye":"dolce-vita-hali-paradiso-plus-4001-white-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-plus-4001-white-ozel-olcu","overlok":"dolce-vita-hali-paradiso-4001-white-ozel-olcu"},"dolce-vita-hali-paradiso-plus-4002-grey-ozel-olcu-biyeli":{"biye":"dolce-vita-hali-paradiso-plus-4002-grey-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-4002-grey-ozel-olcu-kopya","overlok":"dolce-vita-hali-paradiso-4002-grey-ozel-olcu"},"dolce-vita-hali-paradiso-4002-grey-ozel-olcu-kopya":{"biye":"dolce-vita-hali-paradiso-plus-4002-grey-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-4002-grey-ozel-olcu-kopya","overlok":"dolce-vita-hali-paradiso-4002-grey-ozel-olcu"},"dolce-vita-hali-paradiso-4002-grey-ozel-olcu":{"biye":"dolce-vita-hali-paradiso-plus-4002-grey-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-4002-grey-ozel-olcu-kopya","overlok":"dolce-vita-hali-paradiso-4002-grey-ozel-olcu"},"dolce-vita-hali-paradiso-plus-4003-sandy-ozel-olcu-biyeli":{"biye":"dolce-vita-hali-paradiso-plus-4003-sandy-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-plus-4003-sandy-ozel-olcu","overlok":"dolce-vita-hali-paradiso-4003-sandy-ozel-olcu"},"dolce-vita-hali-paradiso-plus-4003-sandy-ozel-olcu":{"biye":"dolce-vita-hali-paradiso-plus-4003-sandy-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-plus-4003-sandy-ozel-olcu","overlok":"dolce-vita-hali-paradiso-4003-sandy-ozel-olcu"},"dolce-vita-hali-paradiso-4003-sandy-ozel-olcu":{"biye":"dolce-vita-hali-paradiso-plus-4003-sandy-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-plus-4003-sandy-ozel-olcu","overlok":"dolce-vita-hali-paradiso-4003-sandy-ozel-olcu"},"dolce-vita-hali-paradiso-plus-4004-beige-ozel-olcu-biyeli":{"biye":"dolce-vita-hali-paradiso-plus-4004-beige-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-plus-4004-beige-ozel-olcu","overlok":"dolce-vita-hali-paradiso-4004-beige-ozel-olcu"},"dolce-vita-hali-paradiso-plus-4004-beige-ozel-olcu":{"biye":"dolce-vita-hali-paradiso-plus-4004-beige-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-plus-4004-beige-ozel-olcu","overlok":"dolce-vita-hali-paradiso-4004-beige-ozel-olcu"},"dolce-vita-hali-paradiso-4004-beige-ozel-olcu":{"biye":"dolce-vita-hali-paradiso-plus-4004-beige-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-plus-4004-beige-ozel-olcu","overlok":"dolce-vita-hali-paradiso-4004-beige-ozel-olcu"},"dolce-vita-hali-paradiso-plus-4005-white-ozel-olcu-biyeli":{"biye":"dolce-vita-hali-paradiso-plus-4005-white-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-4005-white-ozel-olcu-kopya","overlok":"dolce-vita-hali-paradiso-4005-white-ozel-olcu"},"dolce-vita-hali-paradiso-4005-white-ozel-olcu-kopya":{"biye":"dolce-vita-hali-paradiso-plus-4005-white-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-4005-white-ozel-olcu-kopya","overlok":"dolce-vita-hali-paradiso-4005-white-ozel-olcu"},"dolce-vita-hali-paradiso-4005-white-ozel-olcu":{"biye":"dolce-vita-hali-paradiso-plus-4005-white-ozel-olcu-biyeli","bordur":"dolce-vita-hali-paradiso-4005-white-ozel-olcu-kopya","overlok":"dolce-vita-hali-paradiso-4005-white-ozel-olcu"},"dolce-vita-hali-tokyo-301-antrasit-kesme-hali":{"biye":"dolce-vita-hali-tokyo-301-antrasit-kesme-hali","overlok":"dolce-vita-hali-tokyo-301-antrasit-kesme-hali","bordur":"dolce-vita-hali-tokyo-301-antrasit-kesme-hali"},"dolce-vita-hali-tokyo-301-beyaz-kesme-hali":{"biye":"dolce-vita-hali-tokyo-301-beyaz-kesme-hali","overlok":"dolce-vita-hali-tokyo-301-beyaz-kesme-hali","bordur":"dolce-vita-hali-tokyo-301-beyaz-kesme-hali"},"dolce-vita-hali-tokyo-301-gri-kesme-hali":{"biye":"dolce-vita-hali-tokyo-301-gri-kesme-hali","overlok":"dolce-vita-hali-tokyo-301-gri-kesme-hali","bordur":"dolce-vita-hali-tokyo-301-gri-kesme-hali"},"dolce-vita-hali-tokyo-301-kahve-kesme-hali":{"biye":"dolce-vita-hali-tokyo-301-kahve-kesme-hali","overlok":"dolce-vita-hali-tokyo-301-kahve-kesme-hali","bordur":"dolce-vita-hali-tokyo-301-kahve-kesme-hali"},"dolce-vita-hali-monza-4201-stripe-ozel-olcu-hali":{"biye":"dolce-vita-hali-monza-4201-stripe-ozel-olcu-hali","bordur":"dolce-vita-hali-monza-4201-stripe-ozel-olcu-hali","overlok":"dolce-vita-hali-monza-4201-stripe-ozel-olcu-hali"},"dolce-vita-hali-monza-4202-mustard-ozel-olcu-hali":{"biye":"dolce-vita-hali-monza-4202-mustard-ozel-olcu-hali","overlok":"dolce-vita-hali-monza-4202-mustard-ozel-olcu-hali","bordur":"dolce-vita-hali-monza-4202-mustard-ozel-olcu-hali"},"dolce-vita-hali-monza-4203-tangle-ozel-olcu-hali":{"biye":"dolce-vita-hali-monza-4203-tangle-ozel-olcu-hali","overlok":"dolce-vita-hali-monza-4203-tangle-ozel-olcu-hali","bordur":"dolce-vita-hali-monza-4203-tangle-ozel-olcu-hali"},"dolce-vita-hali-monza-4204-rust-ozel-olcu-hali":{"biye":"dolce-vita-hali-monza-4204-rust-ozel-olcu-hali","overlok":"dolce-vita-hali-monza-4204-rust-ozel-olcu-hali","bordur":"dolce-vita-hali-monza-4204-rust-ozel-olcu-hali"},"dolce-vita-hali-monza-4205-stairway-ozel-olcu-hali":{"biye":"dolce-vita-hali-monza-4205-stairway-ozel-olcu-hali","overlok":"dolce-vita-hali-monza-4205-stairway-ozel-olcu-hali","bordur":"dolce-vita-hali-monza-4205-stairway-ozel-olcu-hali"},"dolce-vita-hali-monza-4206-wave-ozel-olcu-hali-1":{"biye":"dolce-vita-hali-monza-4206-wave-ozel-olcu-hali-1","overlok":"dolce-vita-hali-monza-4206-wave-ozel-olcu-hali-1","bordur":"dolce-vita-hali-monza-4206-wave-ozel-olcu-hali-1"},"dolce-vita-hali-monza-4207-silver-stone-ozel-olcu-hali":{"biye":"dolce-vita-hali-monza-4207-silver-stone-ozel-olcu-hali","overlok":"dolce-vita-hali-monza-4207-silver-stone-ozel-olcu-hali","bordur":"dolce-vita-hali-monza-4207-silver-stone-ozel-olcu-hali"},"dolce-vita-hali-puffy-281-beige-ozel-olcu-hali":{"biye":"dolce-vita-hali-puffy-281-beige-ozel-olcu-hali","bordur":"dolce-vita-hali-puffy-281-beige-ozel-olcu-hali","overlok":"dolce-vita-hali-puffy-281-beige-ozel-olcu-hali"},"dolce-vita-hali-puffy-282-granit-ozel-olcu-hali":{"overlok":"dolce-vita-hali-puffy-282-granit-ozel-olcu-hali","biye":"dolce-vita-hali-puffy-282-granit-ozel-olcu-hali","bordur":"dolce-vita-hali-puffy-282-granit-ozel-olcu-hali"},"dolce-vita-hali-puffy-283-white-ozel-olcu-hali":{"biye":"dolce-vita-hali-puffy-283-white-ozel-olcu-hali","bordur":"dolce-vita-hali-puffy-283-white-ozel-olcu-hali","overlok":"dolce-vita-hali-puffy-283-white-ozel-olcu-hali"},"dolce-vita-hali-garda-6501-mare-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-garda-6501-mare-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-garda-6501-mare-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-garda-6501-mare-modern-hali-ozel-olcu"},"dolce-vita-hali-garda-6502-onda-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-garda-6502-onda-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-garda-6502-onda-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-garda-6502-onda-modern-hali-ozel-olcu"},"dolce-vita-hali-garda-6503-bello-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-garda-6503-bello-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-garda-6503-bello-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-garda-6503-bello-modern-hali-ozel-olcu"},"dolce-vita-hali-garda-6504-zefiro-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-garda-6504-zefiro-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-garda-6504-zefiro-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-garda-6504-zefiro-modern-hali-ozel-olcu"},"dolce-vita-hali-garda-6506-eterno-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-garda-6506-eterno-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-garda-6506-eterno-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-garda-6506-eterno-modern-hali-ozel-olcu"},"dolce-vita-hali-garda-6507-mistero-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-garda-6507-mistero-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-garda-6507-mistero-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-garda-6507-mistero-modern-hali-ozel-olcu"},"dolce-vita-hali-record-9811-magia-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-record-9811-magia-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-record-9811-magia-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-record-9811-magia-modern-hali-ozel-olcu"},"dolce-vita-hali-record-9812-sogno-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-record-9812-sogno-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-record-9812-sogno-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-record-9812-sogno-modern-hali-ozel-olcu"},"dolce-vita-hali-record-9813-lumina-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-record-9813-lumina-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-record-9813-lumina-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-record-9813-lumina-modern-hali-ozel-olcu"},"dolce-vita-hali-record-9814-filato-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-record-9814-filato-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-record-9814-filato-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-record-9814-filato-modern-hali-ozel-olcu"},"dolce-vita-hali-record-9815-lieve-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-record-9815-lieve-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-record-9815-lieve-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-record-9815-lieve-modern-hali-ozel-olcu"},"dolce-vita-hali-record-9816-lunare-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-record-9816-lunare-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-record-9816-lunare-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-record-9816-lunare-modern-hali-ozel-olcu"},"dolce-vita-hali-record-9817-voluta-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-record-9817-voluta-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-record-9817-voluta-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-record-9817-voluta-modern-hali-ozel-olcu"},"dolce-vita-hali-record-9818-lunaria-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-record-9818-lunaria-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-record-9818-lunaria-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-record-9818-lunaria-modern-hali-ozel-olcu"},"dolce-vita-hali-record-9819-opalina-modern-hali-ozel-olcu":{"biye":"dolce-vita-hali-record-9819-opalina-modern-hali-ozel-olcu","bordur":"dolce-vita-hali-record-9819-opalina-modern-hali-ozel-olcu","overlok":"dolce-vita-hali-record-9819-opalina-modern-hali-ozel-olcu"}};
  var QUALITIES={
    paradiso:{
      label:'Paradiso Plus',
      edges:['biye','bordur','overlok'],
      desens:[
        {i:0,code:'4001 White',h:'dolce-vita-hali-paradiso-plus-4001-white-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/PARADISOPLUS4001BORDURWHITE-017229_97018271-f1b1-4868-a0eb-35d4cfd8a107.jpg?width=800',bg:'linear-gradient(135deg,#d4c4b0,#e8ddd0)'},
        {i:1,code:'4002 Grey',h:'dolce-vita-hali-paradiso-4002-grey-ozel-olcu-kopya',img:'https://dolcevitahali.com/cdn/shop/files/PARADISOPLUS4002BORDURGRAY-017228.jpg?width=800',bg:'linear-gradient(135deg,#8a8580,#a09890)'},
        {i:2,code:'4003 Sandy',h:'dolce-vita-hali-paradiso-plus-4003-sandy-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/PARADISOPLUS4003BORDURSANDY-017234.jpg?width=800',bg:'linear-gradient(135deg,#c4a882,#d8c4a8)'},
        {i:3,code:'4004 Beige',h:'dolce-vita-hali-paradiso-plus-4004-beige-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/PARADISO_PLUS_4004_BORDUR_BEIGE-017232.jpg?width=800',bg:'linear-gradient(135deg,#c8b898,#ddd0b8)'},
        {i:4,code:'4005 White',h:'dolce-vita-hali-paradiso-4005-white-ozel-olcu-kopya',img:'https://dolcevitahali.com/cdn/shop/files/PARADISO_PLUS_4005_BORDUR_WHITE-017233.jpg?width=800',bg:'linear-gradient(135deg,#b8b0a8,#ccc8c0)'}
      ]
    },
    tokyo:{
      label:'Tokyo',
      edges:['biye','overlok'],
      desens:[
        {i:0,code:'301 Antrasit',h:'dolce-vita-hali-tokyo-301-antrasit-kesme-hali',img:'https://dolcevitahali.com/cdn/shop/files/tokyo_301_anthracite_modern_salon_halisi_mutfak_halisi_kilim_1.webp?width=800',bg:'linear-gradient(135deg,#484440,#605850)'},
        {i:1,code:'301 Gri',h:'dolce-vita-hali-tokyo-301-gri-kesme-hali',img:'https://dolcevitahali.com/cdn/shop/files/tokyo_301_grey_modern_salon_halisi_mutfak_halisi_kilim_1_87419138-9728-4fb4-9903-94fda77bc802.webp?width=800',bg:'linear-gradient(135deg,#908880,#a8a098)'},
        {i:2,code:'301 Kahve',h:'dolce-vita-hali-tokyo-301-kahve-kesme-hali',img:'https://dolcevitahali.com/cdn/shop/files/tokyo_301_brown_modern_salon_halisi_mutfak_halisi_kilim_1.webp?width=800',bg:'linear-gradient(135deg,#7a6050,#9a8070)'}
      ]
    },
    monza:{
      label:'Monza',
      edges:['biye','overlok'],
      desens:[
        {i:0,code:'4201 Stripe',h:'dolce-vita-hali-monza-4201-stripe-ozel-olcu-hali',img:'https://dolcevitahali.com/cdn/shop/files/monza_4201_stripe_modern_salon_halisi_akrilik_hali_1_1cf50eb9-e9d1-4449-8577-d9f3b8a13ff3.webp?width=800',bg:'linear-gradient(135deg,#c8b898,#d8c8a8)'},
        {i:1,code:'4202 Mustard',h:'dolce-vita-hali-monza-4202-mustard-ozel-olcu-hali',img:'https://dolcevitahali.com/cdn/shop/files/monza_4202_mustard_modern_salon_halisi_akrilik_hali_1_f9c34a85-901b-46e1-9bd6-bf2774834786.webp?width=800',bg:'linear-gradient(135deg,#b89848,#c8a858)'},
        {i:2,code:'4203 Tangle',h:'dolce-vita-hali-monza-4203-tangle-ozel-olcu-hali',img:'https://dolcevitahali.com/cdn/shop/files/monza_4203_tangle_modern_salon_halisi_akrilik_hali_1_2b268d84-fd08-4a5b-b3f8-ff754e71588b.webp?width=800',bg:'linear-gradient(135deg,#a89080,#b8a090)'},
        {i:3,code:'4204 Rust',h:'dolce-vita-hali-monza-4204-rust-ozel-olcu-hali',img:'https://dolcevitahali.com/cdn/shop/files/monza_4204_rust_modern_salon_halisi_akrilik_hali_1_5dbf03c0-802c-4d37-a4a8-d319c10d9a97.webp?width=800',bg:'linear-gradient(135deg,#a06040,#b87050)'},
        {i:4,code:'4205 Stairway',h:'dolce-vita-hali-monza-4205-stairway-ozel-olcu-hali',img:'https://dolcevitahali.com/cdn/shop/files/monza_4205_stairway_modern_salon_halisi_akrilik_hali_1_c0fc8087-a000-43a2-b38e-36bfd110bac9.webp?width=800',bg:'linear-gradient(135deg,#908880,#a09890)'},
        {i:5,code:'4206 Wave',h:'dolce-vita-hali-monza-4206-wave-ozel-olcu-hali-1',img:'https://dolcevitahali.com/cdn/shop/files/monza_4206_wave_modern_salon_halisi_akrilik_hali_1_161576ff-0328-41c2-8265-6c5c7708c375.webp?width=800',bg:'linear-gradient(135deg,#b8a888,#c8b898)'},
        {i:6,code:'4207 Silver Stone',h:'dolce-vita-hali-monza-4207-silver-stone-ozel-olcu-hali',img:'https://dolcevitahali.com/cdn/shop/files/monza_4207_silverstone_modern_salon_halisi_akrilik_hali_1_be01868a-55b5-4fa6-8a98-f806126124de.webp?width=800',bg:'linear-gradient(135deg,#989088,#a8a098)'}
      ]
    },
    puffy:{
      label:'Puffy',
      edges:['biye','overlok'],
      desens:[
        {i:0,code:'281 Beige',h:'dolce-vita-hali-puffy-281-beige-ozel-olcu-hali',img:'https://dolcevitahali.com/cdn/shop/files/puffy_281_beige_shaggy_hali_yumusak_hali_1.webp?width=800',bg:'linear-gradient(135deg,#d8c8b0,#e8d8c0)'},
        {i:1,code:'282 Granit',h:'dolce-vita-hali-puffy-282-granit-ozel-olcu-hali',img:'https://dolcevitahali.com/cdn/shop/files/puffy_282_granit_shaggy_hali_yumusak_hali_1_9f829409-709b-4fa7-a533-83695cae95ef.webp?width=800',bg:'linear-gradient(135deg,#787068,#888078)'},
        {i:2,code:'283 White',h:'dolce-vita-hali-puffy-283-white-ozel-olcu-hali',img:'https://dolcevitahali.com/cdn/shop/files/puffy_283_white_shaggy_hali_yumusak_hali_1_17629714-442a-41b3-8727-78f8ffc6c2a7.webp?width=800',bg:'linear-gradient(135deg,#e8e0d8,#f0e8e0)'}
      ]
    },
    garda:{
      label:'Garda',
      edges:['biye','overlok'],
      desens:[
        {i:0,code:'6501 Mare',h:'dolce-vita-hali-garda-6501-mare-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/GARDA6501_1JPG.jpg?width=800',bg:'linear-gradient(135deg,#607080,#788898)'},
        {i:1,code:'6502 Onda',h:'dolce-vita-hali-garda-6502-onda-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/GARDA6502WEBSITEKUCUK_1.jpg?width=800',bg:'linear-gradient(135deg,#b0a898,#c0b8a8)'},
        {i:2,code:'6503 Bello',h:'dolce-vita-hali-garda-6503-bello-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/GARDA6503WEBSITEKUCUK_1.jpg?width=800',bg:'linear-gradient(135deg,#908878,#a09888)'},
        {i:3,code:'6504 Zefiro',h:'dolce-vita-hali-garda-6504-zefiro-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/GARDA6504WEBSITEKUCUK_1.jpg?width=800',bg:'linear-gradient(135deg,#c8b8a0,#d8c8b0)'},
        {i:4,code:'6506 Eterno',h:'dolce-vita-hali-garda-6506-eterno-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/GARDA6506WEBSITEKUCUK_1.jpg?width=800',bg:'linear-gradient(135deg,#a09080,#b0a090)'},
        {i:5,code:'6507 Mistero',h:'dolce-vita-hali-garda-6507-mistero-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/GARDA6507WEBSITEKUCUK_1.jpg?width=800',bg:'linear-gradient(135deg,#887868,#988878)'}
      ]
    },
    record:{
      label:'Record',
      edges:['biye','overlok'],
      desens:[
        {i:0,code:'9811 Magia',h:'dolce-vita-hali-record-9811-magia-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/RECORD9811_1WEBSITEKUCUK.jpg?width=800',bg:'linear-gradient(135deg,#c8c0b8,#d8d0c8)'},
        {i:1,code:'9812 Sogno',h:'dolce-vita-hali-record-9812-sogno-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/RECORD9812_1WEBSITEKUCUK.jpg?width=800',bg:'linear-gradient(135deg,#b8b0a8,#c8c0b8)'},
        {i:2,code:'9813 Lumina',h:'dolce-vita-hali-record-9813-lumina-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/RECORD9813_1WEBSITEKUCUK.jpg?width=800',bg:'linear-gradient(135deg,#d0c8c0,#e0d8d0)'},
        {i:3,code:'9814 Filato',h:'dolce-vita-hali-record-9814-filato-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/RECORD9814_1WEBSITEKUCUKJPG.jpg?width=800',bg:'linear-gradient(135deg,#a89888,#b8a898)'},
        {i:4,code:'9815 Lieve',h:'dolce-vita-hali-record-9815-lieve-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/RECORD9815_1WEBSITEKUCUK.jpg?width=800',bg:'linear-gradient(135deg,#c0b8b0,#d0c8c0)'},
        {i:5,code:'9816 Lunare',h:'dolce-vita-hali-record-9816-lunare-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/RECORD9816_1WEBSITEKUCUK.jpg?width=800',bg:'linear-gradient(135deg,#b0a8a0,#c0b8b0)'},
        {i:6,code:'9817 Voluta',h:'dolce-vita-hali-record-9817-voluta-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/RECORD9817_1WEBSITEKUCUK.jpg?width=800',bg:'linear-gradient(135deg,#a89080,#b8a090)'},
        {i:7,code:'9818 Lunaria',h:'dolce-vita-hali-record-9818-lunaria-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/GARDA6501_1PNG_1.jpg?width=800',bg:'linear-gradient(135deg,#c8c0b0,#d8d0c0)'},
        {i:8,code:'9819 Opalina',h:'dolce-vita-hali-record-9819-opalina-modern-hali-ozel-olcu',img:'https://dolcevitahali.com/cdn/shop/files/RECORD9819_1WEBSITEKUCUK.jpg?width=800',bg:'linear-gradient(135deg,#d0c8c0,#e0d8d0)'}
      ]
    }
  };
  var currentQuality='tokyo';

  var KALP_RADII=[0.744,0.684,0.631,0.587,0.553,0.526,0.508,0.495,0.489,0.492,0.504,0.524,0.556,0.605,0.706,0.778,0.706,0.605,0.556,0.524,0.504,0.492,0.489,0.495,0.508,0.526,0.553,0.587,0.631,0.684,0.744,0.809,0.869,0.918,0.954,0.973,0.980,0.978,0.970,0.950,0.917,0.870,0.807,0.728,0.629,0.574,0.629,0.728,0.807,0.870,0.917,0.950,0.970,0.978,0.980,0.973,0.954,0.918,0.869,0.809];
  var baseRadii=new Float32Array(KALP_RADII);
  var radii=new Float32Array(baseRadii);

  function buildPath(r,cx,cy,rx,ry,sc){
    sc=sc||1;var pts=[];
    for(var i=0;i<N;i++){var a=(i/N)*PI2;pts.push({x:cx+rx*r[i]*sc*Math.cos(a),y:cy+ry*r[i]*sc*Math.sin(a)})}
    var d='M'+pts[0].x.toFixed(1)+','+pts[0].y.toFixed(1);
    for(var k=0;k<N;k++){var p0=pts[(k-1+N)%N],p1=pts[k],p2=pts[(k+1)%N],p3=pts[(k+2)%N];
    d+=' C'+(p1.x+T*(p2.x-p0.x)).toFixed(1)+','+(p1.y+T*(p2.y-p0.y)).toFixed(1)+' '+(p2.x-T*(p3.x-p1.x)).toFixed(1)+','+(p2.y-T*(p3.y-p1.y)).toFixed(1)+' '+p2.x.toFixed(1)+','+p2.y.toFixed(1)}
    return d+'Z';
  }

  function buildRectPath(cx,cy,rx,ry,sc){
    sc=sc||1;var cr=Math.min(10,rx*sc*.12,ry*sc*.12);
    var x1=cx-rx*sc,x2=cx+rx*sc,y1=cy-ry*sc,y2=cy+ry*sc;
    return 'M'+(x1+cr).toFixed(1)+','+y1.toFixed(1)
      +' L'+(x2-cr).toFixed(1)+','+y1.toFixed(1)
      +' Q'+x2.toFixed(1)+','+y1.toFixed(1)+' '+x2.toFixed(1)+','+(y1+cr).toFixed(1)
      +' L'+x2.toFixed(1)+','+(y2-cr).toFixed(1)
      +' Q'+x2.toFixed(1)+','+y2.toFixed(1)+' '+(x2-cr).toFixed(1)+','+y2.toFixed(1)
      +' L'+(x1+cr).toFixed(1)+','+y2.toFixed(1)
      +' Q'+x1.toFixed(1)+','+y2.toFixed(1)+' '+x1.toFixed(1)+','+(y2-cr).toFixed(1)
      +' L'+x1.toFixed(1)+','+(y1+cr).toFixed(1)
      +' Q'+x1.toFixed(1)+','+y1.toFixed(1)+' '+(x1+cr).toFixed(1)+','+y1.toFixed(1)
      +' Z';
  }

  function buildUniformPath(cx,cy,rx,ry,sc){
    var r=new Float32Array(N);for(var i=0;i<N;i++)r[i]=1.0;
    return buildPath(r,cx,cy,rx,ry,sc);
  }

  function calcAspect(w,h){
    var aspect=w/h,maxRx=155,maxRy=148,arx,ary;
    if(aspect>=1){arx=maxRx;ary=Math.max(40,Math.min(maxRy,maxRx/aspect))}
    else{ary=maxRy;arx=Math.max(40,Math.min(maxRx,maxRy*aspect))}
    return{rx:arx,ry:ary};
  }

  function mkRadii(harms){
    var r=new Float32Array(N);
    for(var i=0;i<N;i++){var a=(i/N)*PI2;r[i]=.85;
    for(var j=0;j<harms.length;j++) r[i]+=harms[j].a*Math.cos(harms[j].f*a+(harms[j].p||0));
    r[i]=Math.max(.5,Math.min(.98,r[i]))}return r;
  }
  function easeIO(t){return t<.5?4*t*t*t:1-Math.pow(-2*t+2,3)/2}

  var presets=[];
  for(var p=0;p<50;p++){var h=[],n=2+Math.floor(Math.random()*3);
  for(var k=0;k<n;k++) h.push({a:.03+Math.random()*.1,f:2+Math.floor(Math.random()*5),p:Math.random()*PI2});
  presets.push(h)}

  function init(){
    // === AMORF KOTA KONTROLU ===
    var KOTA_URL='https://dolcevita-massimo.ngrok.io/api/amorf-kota';
    fetch(KOTA_URL).then(function(r){return r.json()}).then(function(k){
      if(k.kapali){
        var banner=document.querySelector('.dvb-amorf-banner');
        if(banner){
          var overlay=document.createElement('div');
          overlay.style.cssText='position:absolute;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.75);display:flex;flex-direction:column;align-items:center;justify-content:center;z-index:100;border-radius:inherit;padding:20px;text-align:center;';
          overlay.innerHTML='<div style="font-size:28px;margin-bottom:12px;">\u23F0</div>'
            +'<div style="color:#fff;font-size:16px;font-weight:700;margin-bottom:8px;">\u00dcretim Kapasitesi Doldu</div>'
            +'<div style="color:#ddd;font-size:14px;line-height:1.5;">'+k.mesaj+'</div>';
          banner.style.position='relative';
          banner.appendChild(overlay);
        }
        var cta=document.getElementById('dvb-ab-cta');
        if(cta){cta.style.pointerEvents='none';cta.style.opacity='.3';}
      }
    }).catch(function(){});
    // === KOTA KONTROLU SONU ===
    var wrap=document.getElementById('dvb-ab-pvw');
    var svg=document.getElementById('dvb-ab-svg');
    var finger=document.getElementById('dvb-ab-finger');
    var op=document.getElementById('dvb-ab-op');
    var ip=document.getElementById('dvb-ab-ip');
    var sk=document.getElementById('dvb-ab-sk');
    var prodImg=document.getElementById('dvb-ab-img');
    var fabRect=document.querySelector('[clip-path*=dvb-oc] rect');
    var banner=document.querySelector('.dvb-amorf-banner');
    if(!wrap||!svg||!op||!banner) return;

    var wIn=document.getElementById('dvb-ab-w'),hIn=document.getElementById('dvb-ab-h');
    var introPlayed=true,introRunning=false;

    function getDims(){
      var w=parseFloat(wIn?wIn.value:'')||80;
      var h=parseFloat(hIn?hIn.value:'')||100;
      return{w:w,h:h};
    }

    function upd(){
      var dims=getDims();
      var asp=calcAspect(dims.w,dims.h);
      liveRX=asp.rx;liveRY=asp.ry;
      var isOverlok=selE==='overlok';
      var pxPerCm=(2*liveRX)/Math.max(dims.w,50);
      var edgeCm=isOverlok?0:(EDGE_CM[selE]||2);
      var ep=edgeCm*pxPerCm;
      var avgR=(liveRX+liveRY)/2;
      innerScale=ep>0?Math.max(0.85,1-ep/avgR):1;
      var o,i;
      if(currentShape==='amorf'){
        o=buildPath(radii,CX,CY,liveRX,liveRY);
        i=isOverlok?o:buildPath(radii,CX,CY,liveRX,liveRY,innerScale);
      }else if(currentShape==='dikdortgen'){
        o=buildRectPath(CX,CY,liveRX,liveRY);
        i=isOverlok?o:buildRectPath(CX,CY,liveRX-ep,liveRY-ep);
      }else if(currentShape==='oval'){
        o=buildUniformPath(CX,CY,liveRX,liveRY);
        i=isOverlok?o:buildUniformPath(CX,CY,liveRX-ep,liveRY-ep);
      }else if(currentShape==='daire'){
        var cr=Math.min(liveRX,liveRY);
        o=buildUniformPath(CX,CY,cr,cr);
        i=isOverlok?o:buildUniformPath(CX,CY,cr-ep,cr-ep);
      }
      op.setAttribute('d',o);ip.setAttribute('d',i);ip.removeAttribute('transform');sk.setAttribute('d',o);
      if(fabRect)fabRect.style.display=isOverlok?'none':'';
      var stitchW=isOverlok?Math.max(0.4,0.5*pxPerCm):0;
      sk.setAttribute('stroke',isOverlok?'#88807060':'#e8622a33');
      sk.setAttribute('stroke-width',isOverlok?String(stitchW):'1');
      sk.setAttribute('stroke-dasharray',isOverlok?'2 1.5':'none');
    }

    function updD(){
      var dw=document.getElementById('dvb-ab-dimW');
      var dh=document.getElementById('dvb-ab-dimH');
      if(dw)dw.textContent=(wIn.value||'200')+' cm';
      if(dh)dh.textContent=(hIn.value||'300')+' cm';
    }

    function updAll(){updD();upd()}

    function posFinger(idx){
      var a=(idx/N)*PI2,er=radii[idx];
      var fx=CX+liveRX*er*Math.cos(a),fy=CY+liveRY*er*Math.sin(a);
      var sr=svg.getBoundingClientRect(),wr=wrap.getBoundingClientRect();
      if(sr.width>0){
        var px=(sr.left-wr.left)+fx*(sr.width/400)-16;
        var py=(sr.top-wr.top)+fy*(sr.height/360)-6;
        finger.style.transform='translate('+px.toFixed(0)+'px,'+py.toFixed(0)+'px) rotate('+(Math.atan2(Math.sin(a),Math.cos(a))*57-90).toFixed(0)+'deg)';
      }
    }

    function startIntro(){
      if(introPlayed||currentShape!=='amorf') return;
      introPlayed=true;introRunning=true;
      finger.style.display='block';finger.style.transition='none';finger.style.opacity='1';
      var fr=0,tot=200,startR=new Float32Array(baseRadii);
      var tgt=new Float32Array(N);
      for(var i=0;i<N;i++){tgt[i]=baseRadii[i]+.08*Math.sin(2*i/N*PI2+.5)+.05*Math.cos(4*i/N*PI2+1.8);tgt[i]=Math.max(.5,Math.min(.98,tgt[i]))}
      function tick(){
        fr++;var p=Math.min(1,fr/tot),e=easeIO(p),fi=Math.floor(e*N*1.3)%N;
        for(var i=0;i<N;i++){
          var d=Math.min(Math.abs(i-fi),Math.abs(i-fi+N),Math.abs(i-fi-N));
          var inf=Math.max(0,1-d/12);inf*=inf;
          radii[i]=startR[i]*(1-e*.5)+tgt[i]*(e*.5)+.07*inf*Math.sin(e*Math.PI);
          radii[i]=Math.max(.5,Math.min(.98,radii[i]));
        }
        upd();posFinger(fi);
        var al=1;if(p<.12)al=p/.12;else if(p>.88)al=(1-p)/.12;
        finger.style.opacity=Math.max(0,Math.min(1,al)).toFixed(2);
        if(p<1){requestAnimationFrame(tick)}
        else{introRunning=false;finger.style.transition='opacity .5s';finger.style.opacity='0';
        setTimeout(function(){finger.style.display='none';wrap.style.cursor='grab'},600);
        baseRadii.set(radii)}
      }
      requestAnimationFrame(tick);
    }

    upd();
    if(typeof IntersectionObserver!=='undefined'){
      var obs=new IntersectionObserver(function(en){
        if(en[0].isIntersecting&&!introPlayed&&currentShape==='amorf'){setTimeout(startIntro,300);obs.disconnect()}
      },{threshold:0.3});
      obs.observe(banner);
    } else {setTimeout(startIntro,2000)}

    // Mouse drag (only amorf)
    var dragging=false;
    function sc(e){var r=svg.getBoundingClientRect();return{x:(e.clientX-r.left)/r.width*400,y:(e.clientY-r.top)/r.height*360}}
    function dTE(sx,sy){var a=Math.atan2(sy-CY,sx-CX);if(a<0)a+=PI2;var idx=Math.round((a/PI2)*N)%N;var ex=CX+liveRX*radii[idx]*Math.cos(a),ey=CY+liveRY*radii[idx]*Math.sin(a);return Math.sqrt((sx-ex)*(sx-ex)+(sy-ey)*(sy-ey))}
    svg.addEventListener('mousedown',function(e){if(introRunning||currentShape!=='amorf')return;var c=sc(e);if(dTE(c.x,c.y)<30){dragging=true;wrap.style.cursor='grabbing';e.preventDefault()}});
    window.addEventListener('mousemove',function(e){if(!dragging||introRunning)return;var r=svg.getBoundingClientRect();var sx=(e.clientX-r.left)/r.width*400,sy=(e.clientY-r.top)/r.height*360;var a=Math.atan2(sy-CY,sx-CX);if(a<0)a+=PI2;var idx=Math.round((a/PI2)*N)%N;var dist=Math.sqrt(Math.pow((sx-CX)/liveRX,2)+Math.pow((sy-CY)/liveRY,2));dist=Math.max(.5,Math.min(.98,dist));for(var i=0;i<N;i++){var d=Math.min(Math.abs(i-idx),Math.abs(i-idx+N),Math.abs(i-idx-N));var inf=Math.max(0,1-d/8);inf*=inf;radii[i]=baseRadii[i]+(dist-baseRadii[i])*inf;radii[i]=Math.max(.5,Math.min(.98,radii[i]))}upd()});
    window.addEventListener('mouseup',function(){if(dragging){dragging=false;wrap.style.cursor=currentShape==='amorf'?'grab':'default';baseRadii.set(radii)}});
    svg.addEventListener('touchstart',function(e){if(introRunning||currentShape!=='amorf')return;var t=e.touches[0],r=svg.getBoundingClientRect();var sx=(t.clientX-r.left)/r.width*400,sy=(t.clientY-r.top)/r.height*360;if(dTE(sx,sy)<40){dragging=true;e.preventDefault()}},{passive:false});
    svg.addEventListener('touchmove',function(e){if(!dragging||introRunning)return;var t=e.touches[0],r=svg.getBoundingClientRect();var sx=(t.clientX-r.left)/r.width*400,sy=(t.clientY-r.top)/r.height*360;var a=Math.atan2(sy-CY,sx-CX);if(a<0)a+=PI2;var idx=Math.round((a/PI2)*N)%N;var dist=Math.sqrt(Math.pow((sx-CX)/liveRX,2)+Math.pow((sy-CY)/liveRY,2));dist=Math.max(.5,Math.min(.98,dist));for(var i=0;i<N;i++){var d=Math.min(Math.abs(i-idx),Math.abs(i-idx+N),Math.abs(i-idx-N));var inf=Math.max(0,1-d/8);inf*=inf;radii[i]=baseRadii[i]+(dist-baseRadii[i])*inf;radii[i]=Math.max(.5,Math.min(.98,radii[i]))}upd();e.preventDefault()},{passive:false});
    svg.addEventListener('touchend',function(){if(dragging){dragging=false;baseRadii.set(radii)}});
    svg.addEventListener('mousemove',function(e){if(dragging||introRunning||currentShape!=='amorf')return;var c=sc(e);wrap.style.cursor=dTE(c.x,c.y)<30?'grab':'default'});

    // Gallery
    var gal=document.getElementById('dvb-ab-gal');
    var galWrap=document.querySelector('.dvb-ab-gl');
    if(gal){
      var gh='';for(var gi=0;gi<100;gi++){var idx=gi%50;var sr=mkRadii(presets[idx]);
      gh+='<div class="dvb-ab-cd" data-p="'+idx+'"><svg viewBox="0 0 44 44"><path d="'+buildPath(sr,22,22,18,18)+'" fill="#e8622a15" stroke="#e8622a" stroke-width=".7"/></svg></div>'}
      gal.innerHTML=gh;
      gal.addEventListener('click',function(e){
        if(currentShape!=='amorf')return;
        var card=e.target.closest('.dvb-ab-cd');if(!card)return;
        var idx=parseInt(card.dataset.p),newR=mkRadii(presets[idx]),startR=new Float32Array(radii),fr=0,tot=40;
        function morph(){fr++;var t=easeIO(Math.min(1,fr/tot));for(var i=0;i<N;i++)radii[i]=startR[i]*(1-t)+newR[i]*t;upd();if(fr<tot)requestAnimationFrame(morph);else baseRadii.set(radii)}
        morph();gal.querySelectorAll('.dvb-ab-cd').forEach(function(c){c.classList.remove('pk')});card.classList.add('pk');
      });
    }

    // Shape selector
    function setShape(shape){
      if(shape===currentShape)return;
      var prevShape=currentShape;
      currentShape=shape;

      // Gallery visibility
      if(galWrap){
        galWrap.style.transition='opacity .3s,max-height .4s';
        if(shape==='amorf'){galWrap.style.opacity='1';galWrap.style.maxHeight='200px';galWrap.style.pointerEvents=''}
        else{galWrap.style.opacity='0';galWrap.style.maxHeight='0';galWrap.style.pointerEvents='none'}
      }

      // Cursor
      wrap.style.cursor=shape==='amorf'?'grab':'default';

      // Daire: sync dimensions
      if(shape==='daire'&&wIn&&hIn){
        var maxV=Math.min(200,Math.max(parseFloat(wIn.value)||200,parseFloat(hIn.value)||200));
        wIn.value=maxV;hIn.value=maxV;updD();
      }

      // Morph animation to new shape
      var startR=new Float32Array(radii),fr=0,tot=35;
      var targetR=new Float32Array(N);
      if(shape==='amorf'){
        for(var i=0;i<N;i++)targetR[i]=baseRadii[i];
      }else{
        for(var i=0;i<N;i++)targetR[i]=.96;
      }
      function morphShape(){
        fr++;var t=easeIO(Math.min(1,fr/tot));
        for(var i=0;i<N;i++)radii[i]=startR[i]*(1-t)+targetR[i]*t;
        upd();
        if(fr<tot)requestAnimationFrame(morphShape);
        else{if(shape==='amorf')baseRadii.set(radii)}
      }
      morphShape();

      // Update shape buttons
      document.querySelectorAll('.dvb-ab-sh').forEach(function(b){b.classList.toggle('on',b.dataset.s===shape)});

      // Hint text
      var hint=document.querySelector('.dvb-ab-ht strong');
      if(hint){
        if(shape==='amorf')hint.textContent='\u015Eeklini sen belirle, \u00f6l\u00e7\u00fcs\u00fcn\u00fc sen se\u00e7.';
        else if(shape==='dikdortgen')hint.textContent='Klasik dikd\u00f6rtgen, \u00f6l\u00e7\u00fcs\u00fcn\u00fc sen se\u00e7.';
        else if(shape==='oval')hint.textContent='Zarif oval form, \u00f6l\u00e7\u00fcs\u00fcn\u00fc sen se\u00e7.';
        else if(shape==='daire')hint.textContent='Kusursuz daire, \u00e7ap\u0131n\u0131 sen se\u00e7.';
      }
    }

    document.querySelectorAll('.dvb-ab-sh').forEach(function(b){
      b.addEventListener('click',function(){setShape(b.dataset.s)});
    });

    // Quality tabs
    function renderDesens(){
      var q=QUALITIES[currentQuality],patsEl=document.querySelector('.dvb-ab-pats');
      if(!patsEl)return;
      var ph='';
      for(var di=0;di<q.desens.length;di++){
        var ds=q.desens[di];
        ph+='<div class="dvb-ab-pat'+(di===0?' on':'')+'" data-i="'+di+'" data-h="'+ds.h+'" data-img="'+ds.img+'" data-code="'+ds.code+'"><i style="background:'+ds.bg+'"></i></div>';
      }
      patsEl.innerHTML=ph;
      selH=q.desens[0].h;
      if(prodImg&&q.desens[0].img) prodImg.setAttribute('href',q.desens[0].img); upd();
      var dlbl=document.getElementById('dvb-ab-lbl-desen');if(dlbl)dlbl.textContent='Desen \u00b7 '+q.desens[0].code;
    }

    function scrollActiveTabIntoView(){
      var active = document.querySelector('.dvb-ab-tab.on');
      var container = document.querySelector('.dvb-ab-tabs');
      if (!active || !container) return;
      // Mobilde justify-content:flex-start olduğu için kalite sırası ilk eleman görünür olur.
      // Ama kullanıcı diğer tab'a tıkladığında o da görünür alana gelmeli.
      var aL = active.offsetLeft, aR = aL + active.offsetWidth;
      var cL = container.scrollLeft, cR = cL + container.clientWidth;
      if (aL < cL) container.scrollLeft = Math.max(0, aL - 8);
      else if (aR > cR) container.scrollLeft = aR - container.clientWidth + 8;
    }

    function setQuality(q){
      if(q===currentQuality)return;
      currentQuality=q;
      // Update tabs
      document.querySelectorAll('.dvb-ab-tab').forEach(function(t){t.classList.toggle('on',t.dataset.q===q);});
      scrollActiveTabIntoView();
      // Update title
      var titleEl=document.querySelector('.dvb-ab-qual em');
      if(titleEl) titleEl.textContent=QUALITIES[q].label;
      // Render desens
      renderDesens();
      // Bordur toggle
      var bordurBtn=document.querySelector('.dvb-ab-eb[data-e="bordur"]');
      if(bordurBtn){
        var hasBordur=QUALITIES[q].edges.indexOf('bordur')>=0;
        bordurBtn.style.display=hasBordur?'':'none';
        if(!hasBordur&&selE==='bordur'){
          selE='biye';
          document.querySelectorAll('.dvb-ab-eb').forEach(function(x){x.classList.remove('on')});
          var biyeBtn=document.querySelector('.dvb-ab-eb[data-e="biye"]');
          if(biyeBtn)biyeBtn.classList.add('on');
          var ss=document.getElementById('dvb-ab-ss');if(ss)ss.style.opacity='1';
          upd();
        }
      }
    }

    // Init quality - setQuality ile tam refresh (desens, edges, label)
    document.querySelectorAll('.dvb-ab-tab').forEach(function(t){
      t.addEventListener('click',function(){setQuality(t.dataset.q)});
    });
    {
      var __initQ = currentQuality;
      currentQuality = '__null__';
      setQuality(__initQ);
    }

    // Pattern click (event delegation)
    document.querySelector('.dvb-ab-pats').addEventListener('click',function(e){
      var b=e.target.closest('.dvb-ab-pat');if(!b)return;
      document.querySelectorAll('.dvb-ab-pat').forEach(function(x){x.classList.remove('on')});b.classList.add('on');
      selH=b.dataset.h;
      if(prodImg&&b.dataset.img) prodImg.setAttribute('href',b.dataset.img); upd();
      var dlbl=document.getElementById('dvb-ab-lbl-desen');if(dlbl&&b.dataset.code)dlbl.textContent='Desen \u00b7 '+b.dataset.code;
    });

    // Edge type
    document.querySelectorAll('.dvb-ab-eb').forEach(function(b){b.addEventListener('click',function(){
      document.querySelectorAll('.dvb-ab-eb').forEach(function(x){x.classList.remove('on')});b.classList.add('on');selE=b.dataset.e;
      upd();
      var ss=document.getElementById('dvb-ab-ss');if(ss)ss.style.opacity=b.dataset.e==='overlok'?'.3':'1';
    })});

    // Swatches
    document.querySelectorAll('.dvb-ab-sw').forEach(function(s){s.addEventListener('click',function(){
      document.querySelectorAll('.dvb-ab-sw').forEach(function(x){x.classList.remove('on')});s.classList.add('on');
      var c=s.dataset.c,fb=document.getElementById('dvb-ab-fb');
      if(fb){var r=parseInt(c.slice(1,3),16),g=parseInt(c.slice(3,5),16),b=parseInt(c.slice(5,7),16);
      var lt='#'+((1<<24)+(Math.min(255,r+20)<<16)+(Math.min(255,g+20)<<8)+Math.min(255,b+20)).toString(16).slice(1);
      var dk='#'+((1<<24)+(Math.max(0,r-15)<<16)+(Math.max(0,g-15)<<8)+Math.max(0,b-15)).toString(16).slice(1);
      fb.innerHTML='<rect width="12" height="12" fill="'+c+'"/><line x1="0" y1="0" x2="12" y2="0" stroke="'+dk+'" stroke-width=".5"/><line x1="6" y1="0" x2="6" y2="12" stroke="'+lt+'" stroke-width=".3"/>';}
      var rlbl=document.getElementById('dvb-ab-lbl-renk');if(rlbl){var lv=s.dataset.l||'';rlbl.textContent=lv?'Renk \u00b7 '+lv:'Renk';}
    })});

    // Dims — linked to shape update + validation
    function clampInput(el,min,max){
      var v=parseInt(el.value);if(!v||isNaN(v)){el.value=min}else if(v<min){el.value=min}else if(v>max){el.value=max}
    }
    if(wIn){
      wIn.addEventListener('input',function(){
        if(currentShape==='daire'&&hIn){hIn.value=wIn.value}
        updAll();
      });
      wIn.addEventListener('blur',function(){
        clampInput(wIn,50,200);
        if(currentShape==='daire'&&hIn){hIn.value=wIn.value}
        updAll();
      });
    }
    if(hIn){
      hIn.addEventListener('input',function(){
        if(currentShape==='daire'&&wIn){wIn.value=hIn.value}
        updAll();
      });
      hIn.addEventListener('blur',function(){
        clampInput(hIn,50,600);
        if(currentShape==='daire'&&wIn){wIn.value=hIn.value;clampInput(wIn,50,200)}
        updAll();
      });
    }

    // CTA
    var cta=document.getElementById('dvb-ab-cta');
    if(cta)cta.addEventListener('click',function(e){e.preventDefault();
      var w=wIn?wIn.value||'200':'200',h=hIn?hIn.value||'300':'300';
      // Secimleri localStorage'a kaydet
      var selSw=document.querySelector('.dvb-ab-sw.on');
      var edgeColorId=selSw?selSw.dataset.l||'':'';
      var cfg={quality:currentQuality,widthCm:w,heightCm:h,shape:currentShape,edgeType:selE,
        edgeColor:selSw?selSw.dataset.c:'',edgeColorId:edgeColorId,ts:Date.now(),source:'banner'};
      if(currentShape==='amorf')cfg.radii=Array.prototype.slice.call(radii);
      try{localStorage.setItem('ozel_olcu_banner_config',JSON.stringify(cfg))}catch(ex){}
      var tgtH=(HANDLE_MAP[selH]&&HANDLE_MAP[selH][selE])?HANDLE_MAP[selH][selE]:selH;
      window.location.href=BASE+tgtH+'?_ow='+w+'&_oh='+h+'&_shape='+currentShape+'&_edge='+selE+'&_ec='+encodeURIComponent(edgeColorId);
    });

    // === AUTO-CAROUSEL: kalp + 4 rastgele amorf preset arasinda otomatik morph (2026-05-12) ===
    var __autoTimer=null,__autoStopped=false,__carouselSlots=[],__carouselStep=0;
    function __pickCarouselSlots(){
      var pool=[];for(var i=0;i<presets.length;i++)pool.push(i);
      for(var i=pool.length-1;i>0;i--){var j=Math.floor(Math.random()*(i+1));var tmp=pool[i];pool[i]=pool[j];pool[j]=tmp;}
      var slots=[{t:'kalp'}];for(var k=0;k<4;k++)slots.push({t:'preset',idx:pool[k]});return slots;
    }
    function __morphToSlot(slot){
      if(__autoStopped||currentShape!=='amorf')return;
      var newR=(slot.t==='kalp')?new Float32Array(KALP_RADII):mkRadii(presets[slot.idx]);
      var startR=new Float32Array(N);startR.set(radii);
      var fr=0,tot=30;
      function step(){
        if(__autoStopped)return;
        fr++;var ee=easeIO(Math.min(1,fr/tot));
        for(var i=0;i<N;i++)radii[i]=startR[i]*(1-ee)+newR[i]*ee;
        upd();
        if(fr<tot)requestAnimationFrame(step);else baseRadii.set(radii);
      }
      step();
    }
    function __startAutoCarousel(){
      if(__autoStopped)return;
      __carouselSlots=__pickCarouselSlots();
      __carouselStep=0;
      __autoTimer=setInterval(function(){
        if(__autoStopped){clearInterval(__autoTimer);return;}
        if(currentShape!=='amorf')return;
        __carouselStep=(__carouselStep+1)%__carouselSlots.length;
        __morphToSlot(__carouselSlots[__carouselStep]);
      },3500);
    }
    function __stopAutoCarousel(){
      if(__autoStopped)return;
      __autoStopped=true;
      if(__autoTimer){clearInterval(__autoTimer);__autoTimer=null;}
    }
    // Stop hooks: butona tiklayinca / drag baslayinca / olcu degisince
    if(banner)banner.addEventListener('click',function(e){
      if(e.target.closest('.dvb-ab-tab,.dvb-ab-pat,.dvb-ab-eb,.dvb-ab-sh,.dvb-ab-sw,.dvb-ab-cta'))__stopAutoCarousel();
    },true);
    if(wrap){
      wrap.addEventListener('mousedown',__stopAutoCarousel);
      wrap.addEventListener('touchstart',__stopAutoCarousel,{passive:true});
    }
    if(wIn)wIn.addEventListener('input',__stopAutoCarousel);
    if(hIn)hIn.addEventListener('input',__stopAutoCarousel);
    // Intro animasyon (~3.5s) bittikten 1s sonra carousel basla
    setTimeout(__startAutoCarousel,4500);

    // === SLOGAN INJECT (parent .dvb-ab-pv basina) ===
    (function(){
      var pvWrap=document.getElementById('dvb-ab-pvw');
      var pvCont=pvWrap?pvWrap.parentElement:null;
      if(pvCont&&!pvCont.querySelector('.dvb-ab-slogan')){
        var s=document.createElement('div');
        s.className='dvb-ab-slogan';
        s.textContent='İstediğin şekilde, istediğin boyutta';
        pvCont.insertBefore(s,pvCont.firstChild);
      }
    })();
  }

  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();
})();
